import { Component, Input } from '@angular/core';
import { IModalParkingLotModel } from '@types-custom/models/ui/modal-parking-lot-model';
import { Icon } from '@types-custom/models/ui/icon-model';

/*
 ** Modal Parking Lot
 ** Render a modal that displays information about the Parking Lot.
 */

@Component({
  selector: 'citizen-modal-parking-lot',
  templateUrl: './modal-parking-lot.component.html',
  styleUrls: ['./modal-parking-lot.component.scss'],
})
export class ModalParkingLotComponent {
  @Input() properties: IModalParkingLotModel | undefined;
  Icon = Icon;
}
